import { render, staticRenderFns } from "./EraSelector.vue?vue&type=template&id=50f4b130&scoped=true&"
import script from "./EraSelector.vue?vue&type=script&lang=js&"
export * from "./EraSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f4b130",
  null
  
)

export default component.exports